<template>
  <PopupBox
    ref="poupBox"
    class="notification"
    :popup-styles="{ top: 10, left: -10 }"
    placement="bottom-end"
    @visibility-change="handlePopupVisibilityChange"
  >
    <template v-slot:trigger>
      <a href="#" class="notification-button" @click.prevent="closeLastUnreadMessagePopup">
        <NotificationIcon v-if="!unreadNotifications" />
        <div class="notification-icon" v-else>
          <NotificationActiveIcon />
          <div class="messages-counter">{{ unreadNotifications }}</div>
        </div>
      </a>
      <LastUnreadMessagePopup class="last-message-popup" />
    </template>
    <template>
      <NotificationPopupContent
        :notifications="getNotifications"
        :unread-notifications-count="unreadNotifications"
        :is-loading="!isNotificationsDataReady"
        :load-more-callback="loadMoreNotifications"
        :enable-infinite-scroll="isPopupOpen"
      />
    </template>
  </PopupBox>
</template>

<script>
import clsx from 'clsx';
import { mapActions, mapGetters } from 'vuex';
import { LAST_UNREAD_MESSAGE_POPUP_EVENTS } from '../../config';
import { subscribeNotifications, subscribeSelfNotifications, unreadNotifications } from '../../lib';
import LastUnreadMessagePopup from '../last-unread-message-popup';
import NotificationPopupContent from '../notification-popup-content';
import { linkResolver } from '@/shared/lib/route';
import { NotificationActiveIcon, NotificationIcon } from '@/shared/ui/icons';
import { PopupBox, popupToggle } from '@/shared/ui/popup';

export default {
  mixins: [ linkResolver, popupToggle, unreadNotifications, subscribeSelfNotifications, subscribeNotifications ],
  components: { NotificationIcon, NotificationActiveIcon, PopupBox, NotificationPopupContent, LastUnreadMessagePopup },
  computed: {
    ...mapGetters('serverNotificationsModule', ['isNotificationsDataReady', 'getNotifications', 'hasMoreData']),
    isPopupOpen() {
      return this.$refs?.poupBox?.isPopupVisible || false;
    }
  },
  methods: {
    clsx,
    ...mapActions('serverNotificationsModule', ['fetchNotificationsList', 'setNewNotification']),
    async loadMoreNotifications({ page }) {
      if (!this.getNotifications.length) {
        await this.fetchNotificationsList(page);
      }

      return this.hasMoreData;
    },
    closeLastUnreadMessagePopup() {
      this.$eventBus.$emit(LAST_UNREAD_MESSAGE_POPUP_EVENTS.LAST_UNREAD_MESSAGE_POPUP_CLOSE);
    },
  },
};
</script>

<style lang="scss" scoped>
.notification {
  position: relative;
  margin-right: 16px;

  @media (max-width: 1050px) {
    position: static;
  }

  &-button {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &-icon {
    position: relative;
    animation: bell-ring 7s ease-in-out infinite;
    animation-delay: 1s;
  }
}

.last-message-popup {
  position: absolute;
  right: 30px;
  top: -17px;
  width: 350px;

  @media (max-width: 1050px) {
    top: 85px;
    left: 15px;
    right: 15px;
    width: 100%;
  }
}

.messages-counter {
  position: absolute;
  top: -2px;
  right: -5px;
  background-color: #FB923C;
  border-radius: 50%;
  min-width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  margin-left: 8px;
  color: #ffffff;
  font-size: 10px;
  font-weight: bold;
}

@keyframes bell-ring {
  0%   { transform: rotate(0); }
  2%  { transform: rotate(15deg); }
  4%  { transform: rotate(-15deg); }
  6%  { transform: rotate(10deg); }
  8%  { transform: rotate(-10deg); }
  10%  { transform: rotate(5deg); }
  12%  { transform: rotate(-5deg); }
  14%, 100% { transform: rotate(0); }
}
</style>
